
function GridItemEvent(props){
    const {data} = props;
    let allow_booking = false;
    if (data.performances && !data.enable_priority_booking){
      allow_booking = true
    }
    return (
        <>
          <div className="grid-item">
            <div className="slot">
                {data.image_url &&
                    <div className="slot-image">
                        <div className="image-container">
                            <img
                              sizes="(min-width: 1980px) 655px, (min-width: 1040px) calc(31.63vw + 35px), (min-width: 780px) 39.58vw, 89.35vw"
                              srcset={data.image_srcset}
                              src={data.image_url}
                              alt={data.image_alt} />
                            {data.slot_tags &&
                              <div class="tags"> {

                                data.slot_tags.map(tag =>
                                  <div className="tag">{tag.name}</div>
                                )
                              }

                               </div>
                            }

                        </div>
                    </div>
                }
                <div className="slot-content">
                    {data.title &&
                        <h3 className="slot-title font-title font-1" dangerouslySetInnerHTML={{ __html: data.title }} />
                    }
                    <svg class="squiggle" xmlns="http://www.w3.org/2000/svg" width="41" height="5" viewBox="0 0 41 5" fill="none">
                    <path d="M36.0898 1.61848C35.3003 2.26209 34.7297 2.72739 33.46 2.72739C32.1904 2.72739 31.6196 2.26209 30.8298 1.61848C30.6639 1.48332 30.4904 1.34193 30.3044 1.20143C29.498 0.592583 28.4546 0 26.7678 0C24.6917 0 23.5907 0.89762 22.7059 1.61847C21.9164 2.26208 21.3458 2.72738 20.0761 2.72738C18.8065 2.72738 18.2357 2.26208 17.4459 1.61847C16.5613 0.89762 15.46 0 13.3839 0C11.3078 0 10.2067 0.89762 9.32195 1.61847C8.53248 2.26208 7.9619 2.72738 6.69223 2.72738C5.42256 2.72738 4.85183 2.26208 4.06195 1.61847C3.17743 0.897631 2.07609 1.10709e-05 0 1.10709e-05V1.25935C0 1.78533 0.36099 2.2446 0.873287 2.36391C1.58489 2.52965 2.04777 2.90716 2.62986 3.38154C3.51465 4.10239 4.61585 5.00001 6.69223 5.00001C8.7686 5.00001 9.86953 4.10239 10.7542 3.38154C11.5436 2.73796 12.1142 2.27261 13.3839 2.27261C14.6536 2.27261 15.224 2.73796 16.0138 3.38154C16.8986 4.10239 17.9998 5.00001 20.0761 5.00001C22.1525 5.00001 23.2534 4.10239 24.1381 3.38154C24.9276 2.73796 25.4981 2.27261 26.7678 2.27261C27.9583 2.27261 28.5339 2.6816 29.252 3.26301C29.2998 3.30177 29.3483 3.34132 29.3977 3.38154C29.453 3.4266 29.5091 3.47233 29.5663 3.5185C29.8522 3.74937 30.1638 3.99093 30.5244 4.21043C30.5965 4.25433 30.6706 4.29733 30.7468 4.3392C31.1278 4.54854 31.5625 4.72925 32.0738 4.84853C32.4828 4.94394 32.941 5.00002 33.4601 5.00002C35.5363 5.00002 36.6374 4.1024 37.522 3.38155C38.0853 2.92234 38.5372 2.55388 39.211 2.38046C39.7692 2.2368 40.1517 1.72218 40.1517 1.14582V1.10709e-05C38.0756 1.10709e-05 36.9746 0.897631 36.0898 1.61848Z" fill="#091F2C"/>
                    </svg>
                    <div className="slot-info">

                    {data.date_range &&
                        <div className="slot-date te"> <span dangerouslySetInnerHTML={{ __html: data.date_range }}/></div>
                    }
                    {data.duration &&
                        <div className="slot-duration"><span className="">Duration: </span> <span className="">{data.duration}</span></div>
                    }
                    {data.location &&
                        <div className="slot-duration">{data.location}</div>
                    }
                    </div>
                    {data.price &&
                        <div className="slot-price font-bold">From £{data.price}</div>
                    }
                    <div className="button-wrapper">
                    {allow_booking &&
                        <button className="button button-white-border load-performances" data-event={data.id} aria-label={`Quick Book - ${data.title}`}>Quick Book</button>
                    }
                    {data.link_url &&
                        <a href={data.link_url}  className="button" aria-label={`${data.link_title} - ${data.title}`}><span>{data.link_title}</span></a>
                    }

                    </div>


                </div>


            </div>
          </div>
        </>
    )
}

export default GridItemEvent;
